<template>
  <div class="tab">
    <img
      v-if="markerIconMap.get(icon?.name)?.url"
      :src="markerIconMap.get(icon?.name)?.url"
      class="tab-icon"
    >
    <component
      :is="featureIconMap.get(icon?.name)?.svg"
      v-else
      class="tab-icon"
    />
  </div>
</template>

<script>
import {markerIconMap, featureIconMap} from '@/services/MapService/Icons';

export default {
  name: 'IconTab',
  props: {
    tab: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      markerIconMap,
      featureIconMap,
      icon: {
        name: '',
      },
    };
  },
  watch: {
    'tab.icon': {
      handler(newVal) {
        this.icon = newVal;
      },
      deep: true,
    },
  },
  beforeMount() {
    this.icon.name = this.tab?.icon?.name || '';
  },
};
</script>

<style scoped lang="scss">
.tab {
  height: 42px;
  width: 42px;
  display: flex;
  align-items: center;

  &-icon {
    width: 60%;
    height: 60%;
    margin: 0 auto;
  }
}
</style>
